import { createTheme } from '@mui/material/styles'

const theme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      light: '#bcdda3',
      main: '#44b97f',
    },
    secondary: {
      main: '#444444',
    },
  },
  typography: {
    fontFamily: ['"brandon-grotesque"', 'Sans-serif'].join(','),
    h3: { fontSize: '2.75rem' },
  },
  components: {
    MuiPaginationItem: {
      styleOverrides: {
        textPrimary: {
          '&:hover': {
            color: '#000',
          },
          '&:focus': {
            outline: 'none',
            color: '#000',
            backgroundColor: '#FFF',
          },
        },
      },
    },
  },
}

export default createTheme(theme)
